import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

export function getParamFromUrl(url: string, paramKey: string) {
    const question = url.substring(url.indexOf('?') + 1);
    let paramsValue: string | null = null;
    if (question) {
        question.split('&').forEach((item) => {
            const params = item.split('=');
            const [key, value] = params;
            if (key === paramKey) {
                paramsValue = value;
            }
        });
    }
    return paramsValue;
}

export function isLateXModel(model: IElementBaseModel) {
    if (model.props?.addon && model.props.addon?.type === 'latex') {
        return true;
    }
    return false;
}
